// features/auth/authSlice.ts
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

interface ActivateAccountState {
    user: any | null;
    token: string | null;
    isAuthenticated: boolean;
    userData: Object;
    loading: boolean;
    error: { message: string, status: boolean } | null;
}

const initialState: ActivateAccountState = {
    user: null,
    token: null,
    userData: {},
    loading: false,
    isAuthenticated: false,
    error: null,
};

export const activateAccount = createAsyncThunk(
    'activateAccount',
    async ({ token, email }: { token: string; email: string }, thunkAPI) => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/activate`, { params: { token, email } });
            return response.data;
        } catch (err: any) {
            return thunkAPI.rejectWithValue(err.response?.data || {message: 'Server error', status: false});
        }
    }
);

const activateAccountSlice = createSlice({
    name: 'activateAccount',
    initialState,
    reducers: {
        restoreAuth(state) {
            state.token = localStorage.getItem('viart_token');
            state.user = JSON.parse(localStorage.getItem('viart_user') || 'null');
            state.loading = true;
        },
    },
    extraReducers: builder => {
        builder
            .addCase(activateAccount.pending, state => {
                state.loading = true;
                state.error = null;
            })
            .addCase(activateAccount.fulfilled, (state, action) => {
                state.loading = false;
                state.token = action.payload.token;
                state.user = action.payload.user;
                // state.userData = action.payload.userData;
                state.isAuthenticated = true;
                localStorage.setItem('viart_token', action.payload.token);
                localStorage.setItem('viart_user', JSON.stringify(action.payload.user));
            })
            .addCase(activateAccount.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload as {message: string, status: boolean};
                state.isAuthenticated = false;
            });
    },
});

export const { restoreAuth } = activateAccountSlice.actions;
export default activateAccountSlice.reducer;
